import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { Router, Route } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { isEqual } from 'lodash';
import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';
import rootStore from './store';
import App from './containers';
import { CONTEXT } from './config';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import history from '../src/helpers/history';

const { store, persistor } = rootStore;

const theme = createTheme();
class RootComponent extends Component {
  componentWillMount() {
    let { origin, pathname } = window.location;
    let url = `${origin}${CONTEXT}`;

    if (isEqual(pathname, '/') || !pathname.includes(CONTEXT)) {
      window.location.replace(url);
    }
  }

  render() {
    return (
      <Router history={history}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <Route path={CONTEXT} component={App} />
          </ThemeProvider>
        </StyledEngineProvider>
      </Router>
    );
  }
}

const RootComponentContainer = RootComponent;

// PersistGate delays rendering until redux-persist has rehydrated state from sessionStorage.
// Without it, on Normal Reload the app would render with empty auth (rehydration is async), so Fudr/restaurant
// containers would redirect to login before the token was restored. Safe to keep; required for
// session to survive normal refresh when using sessionStorage for persisted Redux state.
ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <IntlProvider locale="en-US" defaultLocale="en-US">
        <RootComponentContainer />
      </IntlProvider>
    </PersistGate>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
